'use strict';

export default function(incident) {
	incident.state = 'Filtered';
}
